const PointsFormatUtil = (points) => {
    if(typeof points == "string") {
        points = parseInt(points);
    }
    points = points.toLocaleString("pt-BR", {maximumFractionDigits:2});

    return points;
}

export default PointsFormatUtil;